/**
 * V334.S18: Central display name + optional age formatter for Discover/Profile cards.
 * Single source of truth — when age is hidden, impossible for downstream to append it.
 */

export interface ProfileWithAgePrivacy {
  name?: string | null;
  show_age?: boolean | string | number | null;
  age?: number | null;
  dob?: string | null;
  date_of_birth?: string | null;
}

/**
 * V334.S18: Normalized age visibility check.
 * Treat as HIDDEN: false, 'false', 0, '0', null, undefined.
 * Treat as VISIBLE only: boolean true.
 */
export function isAgeVisible(showAge: unknown): boolean {
  if (showAge === true) return true;
  if (showAge === false) return false;
  if (showAge === 0 || showAge === '0') return false;
  if (showAge === 'false' || showAge === 'False' || showAge === 'FALSE') return false;
  if (showAge == null || showAge === undefined) return false;
  return false; // default: hidden when unknown
}

/**
 * V334.S18: Returns display title for profile card — "Name" or "Name, Age".
 * Never appends age when privacy says hidden.
 */
export function getDisplayNameWithOptionalAge(
  profile: ProfileWithAgePrivacy,
  computedAge: number | null | undefined
): string {
  const name = profile.name || 'User';
  if (!isAgeVisible(profile.show_age)) return name;
  if (computedAge == null || computedAge === undefined || computedAge <= 0) return name;
  return `${name}, ${computedAge}`;
}
